// import { Button, Icon, Tooltip } from '@pypestream/design-system';
// import { observer } from 'mobx-react-lite';

// import { useLoadingState } from '../../../hooks';
// import { tableStore } from '../../../stores/table-store';

// export const PublishButton = observer(
//   ({ onClick }: { onClick: () => void }) => {
//     const isCurrentRouteLoading = useLoadingState();
//     const { validationMessage } = tableStore;
//     const isValidDraft =
//       validationMessage === 'Version is valid and can be deployed.';

//     const isDraftLoading = !validationMessage || isCurrentRouteLoading;
//     const isPrimaryButton = isDraftLoading || isValidDraft;

//     const button = (
//       <Button
//         size="small"
//         disabled={!isValidDraft}
//         onClick={onClick}
//         variant={isPrimaryButton ? 'primary' : 'warning'}
//       >
//         <Icon name={isPrimaryButton ? 'deploy' : 'info'} slot="prefix" />
//         Publish
//       </Button>
//     );

//     return isPrimaryButton ? (
//       button
//     ) : (
//       <Tooltip>
//         {button}
//         <p slot="content" style={{ whiteSpace: 'pre-line', fontSize: '12px' }}>
//           {validationMessage}
//         </p>
//       </Tooltip>
//     );
//   }
// );

import { Button, Icon, Tooltip } from '@pypestream/design-system';
import { observer } from 'mobx-react-lite';

import { useLoadingState } from '../../../hooks';
import { tableStore } from '../../../stores/table-store';

export const PublishButton = observer(
  ({
    onClick,
    disabled,
    tooltipContent,
  }: {
    onClick: () => void;
    disabled?: boolean;
    tooltipContent?: string;
  }) => {
    const isCurrentRouteLoading = useLoadingState();
    const isInvalidDraft = tableStore.errors?.length > 0;
    const { isWaitingForBackendData, isWaitingForLiveCorpusIdOnly } =
      tableStore;
    const isWaitingForBackend =
      isWaitingForBackendData || isWaitingForLiveCorpusIdOnly;
    const isDisabled =
      isInvalidDraft ||
      isCurrentRouteLoading ||
      isWaitingForBackend ||
      disabled;
    const waitingForBackendTooltip =
      "We're still setting things up. Publishing will be available soon.";
    const effectiveTooltip = isWaitingForBackend
      ? waitingForBackendTooltip
      : tooltipContent;
    const button = (
      <Button
        test-id="ps-publish-version-button"
        size="small"
        disabled={isDisabled}
        onClick={onClick}
        variant="primary"
      >
        <Icon name="deploy" slot="prefix" />
        Publish
      </Button>
    );

    return effectiveTooltip ? (
      <Tooltip content={effectiveTooltip}>{button}</Tooltip>
    ) : (
      button
    );
  }
);
